/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardContent } from '../../models/card-content';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterCardContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterCardContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCardContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CardContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCardContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CardContent>>;
    })
  );
}

apiMasterCardContentGetByCriteriaPost.PATH = '/api/Master/CardContent/GetByCriteria';
